const streamingProtocolTypes = {
    DASH: 'MPEG-DASH',
    HLS: 'M3U',
    SMOOTH_STREAMING: 'ISM',
};

export default streamingProtocolTypes;
